import React, { ChangeEvent } from 'react'
import { Typo } from '..'
import { Container, Field } from './styles'

interface TextFieldProps {
  label?: string
  name: string
  value: string
  onChange: (event: ChangeEvent<HTMLInputElement>) => void

  full?: boolean
}

export const TextField: React.FC<TextFieldProps> = ({
  label,
  name,
  value,
  onChange,
  full = false
}) => {
  return (
    <Container>
      <Typo variant="label" htmlFor={name}>
        {label}
      </Typo>
      <Field
        onChange={onChange}
        value={value}
        name={name}
        id={name}
        full={full}
      />
    </Container>
  )
}
